export const colors = {
    /**
     * Default body text color across the entire site.
     *
     * Use this color to highlight the new products.
     */
    darkGray: '#393D40',
    /**
     * Frequently used on footnote and when the text is disabled.
     */
    mediumGray: '#939598',
    /**
     * Use when text is on a DARK background.
     */
    white: '#FFFFFF',
    /**
     * Use this color to indicate the default and active state of interactive elements such as buttons.
     *
     * Use this default color to highlight icons on pages, etc.
     */
    navyBlue: '#355C7E',
    /**
     * Use this color to indicate the hover state of interactive elements.
     *
     * Use this color for selected state on icons on pages.
     */
    mediumBlue: '#567693',
    /**
     * Use this color to indicate the disabled state of interactive elements.
     */
    lightGray: '#CDD2D5',
    /**
     * This is our standard border and separator color.
     */
    borderGray: '#CCCCCC',
    /**
     * Use this color to highlight Vital Items such as Savings on product cards, etc.
     */
    vitalBlue: '#02ABE3',
    /**
     * Use this color for content backgrounds such as footer.
     */
    lightCream: '#ECE5DD',
    /**
     * Use this color to indicate the positive/success.
     */
    green: '#1ACA79',
    /**
     * Use this color to indicate the warning/important info.
     */
    yellow: '#FFD200',
    /**
     * Use this color to indicate the negative/error.
     */
    red: '#EF3A4C',
    /**
     * Use this color as alternative of white background as needed.
     */
    lightGrayBg: '#F4F7F7',
    /**
     * Use this color to indicate the background color for Products and for FAQ selected state..
     */
    gray: '#E5E9ED',
    /**
     * Use this color to differentiate content by using this background color.
     */
    lightBlue: '#C6D2D4',
    /**
     * Use this color to differentiate content by using this BG color.
     */
    lightGreen: '#C2D0C8',
};
